<div class="metadata-div">

  <span class="input-field-label" [matTooltip]="label ? label : ''" matTooltipPosition="above">
    <span *ngIf="visibility === 'MT_K'">*</span>{{label}}
  </span>

<!--  <div *ngIf="visibility === 'MT_O'" class="only-read-metadata-data-div">-->
<!--    {{humanvalue}}-->
<!--  </div>-->

  <app-meta-data-onlyread *ngIf="visibility === 'MT_O'" [value]="humanvalue" [title]="label"></app-meta-data-onlyread>

  <mat-form-field *ngIf="visibility === 'MT_K' || visibility === 'MT_M'">
    <input matInput #input
           [formControl]="workflowFormControl"
           [value]="humanvalue || value"
           (input)="onInput(input.value)"
           (blur)="onBlur(input.value)">
    <mat-error *ngIf="workflowFormControl.hasError('required')">
      {{'MANDATORY_FIELD' | translate}}
    </mat-error>
    <mat-error *ngIf="workflowFormControl.hasError('itemNotExist') && !isSearchActive">
      {{'RELATED_ITEM_NOT_EXIST' | translate}}
    </mat-error>
    <mat-hint *ngIf="isSearchActive">{{'SEARCHING_FOR_RELATED_ITEM' | translate}}</mat-hint>
  </mat-form-field>

</div>
